// An order's lines as the kitchen priced them — each with its configuration
// (size, base, toppings off the default, halves, bundle picks, modifiers).
// Shared by the tracking page and the order detail in the account.

import { money, type OrderLine } from '../lib/api';

export function OrderLines({ lines }: { lines: OrderLine[] }) {
  return (
    <>
      {lines.map((l) => (
        <div className="co-line" key={l.orderItemId} data-line={l.orderItemId}>
          <span className="q">{l.quantity}×</span>
          <span className="nm">{l.name}
            {l.pizza && <span className="cfg">{l.pizza.sizeName}{l.pizza.baseName ? ` · ${l.pizza.baseName}` : ''}{l.pizza.toppings.filter((x) => x.action !== 'default').map((x) => ` · ${x.action === 'add' ? '+' : 'no'} ${x.toppingName}`).join('')}</span>}
            {l.halfAndHalf && <span className="cfg">{l.halfAndHalf.first.name} / {l.halfAndHalf.second.name} · {l.halfAndHalf.sizeName}</span>}
            {l.picks && <span className="cfg">{l.picks.map((p) => `${p.quantity > 1 ? `${p.quantity}× ` : ''}${p.name ?? p.pizza?.name ?? (p.halfAndHalf ? `${p.halfAndHalf.first.name} / ${p.halfAndHalf.second.name}` : p.slotName)}`).join(' · ')}</span>}
            {l.modifiers.length > 0 && <span className="cfg">{l.modifiers.map((m) => m.optionName).join(' · ')}</span>}
            {l.comments && <span className="cfg">“{l.comments}”</span>}
          </span>
          <span className="amt money">{money(l.lineTotalInCents)}</span>
        </div>
      ))}
    </>
  );
}
